module.exports = __webpack_public_path__ + "img/haichang.5e94a13c.png";